import React, {forwardRef, useEffect, useImperativeHandle, useState} from 'react';
import PropTypes from 'prop-types';
import {Checkbox, Col, Modal, Row, Tag, Typography} from 'antd';
import {useAsync} from 'react-use';

import {getApiList, saveApiLinks} from '@/api/clientApps';
import styles from './styles.module.less';

const LocalApiSelectorModal = forwardRef(({clientAppId, reload}, ref) => {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);

    const [indeterminate, setIndeterminate] = useState(true);
    const [checkAll, setCheckAll] = useState(false);
    const [activeKey, setActiveKey] = useState('localApis');

    const [selApiIds, setSelApiIds] = useState([]);
    const {value: apis = []} = useAsync(() => {
        return getApiList().then(({data}) => {
            let temp = data.filter(api => activeKey == 'localApis' ? api.interfaceType == 'localApis' : api.interfaceType == 'wecomApis');
            return temp || [];
        });
    }, [clientAppId, activeKey]);
    console.log('api value, selApiIds', apis, selApiIds);

    // 载入 apis 之后执行一下此处方法用于重置「全选」状态
    useEffect(() => {
        if (!visible) {
            return;
        }
        console.log('useEffectuseEffectuseEffect');
        setCheckAll(selApiIds.length === apis.length);
        setIndeterminate(selApiIds.length > 0 && selApiIds.length < apis.length);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible, clientAppId, apis]);

    function showModal(apiIds, activeKey) {
        setVisible(true);
        setActiveKey(activeKey);
        setSelApiIds(apiIds);
    }

    function closeModal() {
        setVisible(false);
    }

    useImperativeHandle(ref, () => ({
        showModal,
        closeModal,
    }));

    function onCheckAllChange(e) {
        const checked = e.target.checked;
        console.log('checked', checked);
        setIndeterminate(false);
        setCheckAll(checked);
        setSelApiIds(checked ? apis.map(({id}) => id) : []);
    }

    function onChange(checkedValues) {
        console.log('checked = ', checkedValues);
        setSelApiIds(checkedValues);
        setCheckAll(checkedValues.length === apis.length);
        setIndeterminate(checkedValues.length > 0 && checkedValues.length < apis.length);
    }

    function onOk() {
        console.log(selApiIds);
        setLoading(true);
        saveApiLinks(clientAppId, selApiIds, activeKey)
            .then(data => {
                console.log(data);
                reload();
                closeModal();
            })
            .finally(() => {
                setLoading(false);
            });
    }

    const title = (
        <div className={styles.modalTitle}>
            <div>Api 选择</div>
            <Checkbox
                indeterminate={indeterminate}
                onChange={onCheckAllChange}
                checked={checkAll}
                style={{marginRight: 48}}
            >
                全选
            </Checkbox>
        </div>
    );

    return (
        <Modal
            destroyOnClose
            maskClosable={false}
            visible={visible}
            title={title}
            onCancel={closeModal}
            onOk={onOk}
            confirmLoading={loading}
        >
            <Checkbox.Group onChange={onChange} value={selApiIds}>
                <Row>
                    {apis?.map(api => {
                        // const checked = selApiIds.includes(api.id);
                        // console.log(`selApiIds.includes(${api.id})`, checked);
                        return (
                            <Col span={24} key={api.id} style={{marginBottom: 8}}>
                                <Checkbox value={api.id}>
                                    <Typography.Text strong style={{display: 'block'}}>
                                        {api.apiName}
                                    </Typography.Text>
                                    <Typography.Text type="secondary">{api.apiUrl}</Typography.Text>
                                    <div>
                                        {api.bindApp && <Tag color="red">需关联应用</Tag>}
                                        {api.needAksk && <Tag color="magenta">需 AKSK</Tag>}
                                    </div>
                                </Checkbox>
                            </Col>
                        );
                    })}
                </Row>
            </Checkbox.Group>
        </Modal>
    );
});

LocalApiSelectorModal.displayName = 'LocalApiSelectorModal';

LocalApiSelectorModal.propTypes = {
    clientAppId: PropTypes.string.isRequired,
    reload: PropTypes.func.isRequired,
};

export default LocalApiSelectorModal;
